import type { Accessor } from 'solid-js'
import { m } from '~/paraglide/messages'
import type { ShopBalances } from '~/store/session-ledger'
import { BalancePills } from './balance-pills'

// The dialog shape every Shop purchase decision takes (GLOSSARY.md "Shop
// purchase flow"): an alertdialog the user answers with a button, never by
// pressing Escape.
export const SHOP_ALERT_DIALOG = {
  closeOnEscapeKeyDown: false,
  role: 'alertdialog',
} as const

// The general error dialog's description carries the failed operation's
// error code in place of its `[%s]` placeholder (GLOSSARY.md "Shop general error dialog").
export const shopErrorDescription = (code: string) =>
  m.dialog_something_went_wrong_description().replace('[%s]', code)

// The balance pills over a purchase dialog (GLOSSARY.md "Balance pills"):
// inverted, in the place the header's pills sit, so the spend can be judged
// against what the user has while the header is behind the overlay.
export function PurchaseBalanceOverlay(props: {
  balances: Accessor<ShopBalances | undefined>
  testIdPrefix: string
}) {
  return (
    <BalancePills
      balances={props.balances()}
      class="fixed right-2 top-[calc(8px+var(--safe-area-top))] z-[71] duration-300 animate-in fade-in"
      inverted
      testIdPrefix={props.testIdPrefix}
    />
  )
}
